import { graphql, useStaticQuery } from 'gatsby';

import { useFlatten } from './use-flatten';
import { getProperty } from 'utils';

export const useStaticCompany = () => {
	const results = useStaticQuery(query) || {};
	const key = 'squidex.findCompanySingleton';

	return useFlatten(getProperty(results, key) || {});
};

const query = graphql`
	query useCompanyQuery {
		squidex {
			findCompanySingleton {
				id
				data {
					seo {
						de {
							title
							description
						}
					}

					header {
						de {
							title
						}
					}

					content {
						de {
							preface
							title
							text
						}
					}

					factsContent {
						de {
							backgroundImage {
								localFile {
									childImageSharp {
										gatsbyImageData(layout: FULL_WIDTH, quality: 100)
									}
								}
								...SquidexLocalFileProps
							}
						}
					}

					factsItems {
						de {
							key
							textBefore
							textAfter
						}
					}

					departments {
						de {
							text
						}
					}

					membershipsHeader {
						de {
							title
						}
					}

					membershipsItems {
						de {
							title
							text
						}
					}

					membershipsImages {
						iv {
							localFile {
								childImageSharp {
									gatsbyImageData(
										width: 1200
										height: 900
										quality: 100
										layout: CONSTRAINED
										transformOptions: { fit: COVER, cropFocus: CENTER }
									)
								}
							}
							...SquidexLocalFileProps
						}
					}

					historyContent {
						de {
							title
						}
					}

					historyItems {
						de {
							date
							text
							image {
								localFile {
									childImageSharp {
										gatsbyImageData(layout: CONSTRAINED, width: 500, quality: 100)
									}
								}
								...SquidexLocalFileProps
							}
						}
					}
				}
			}
		}
	}
`;
